import getSurfaceStore from '../store/store';
import { getDateString, getTimestamp, OwaDate } from 'owa-datetime';
import { mutator, mutatorAction } from 'satcheljs';
import { onAgendaViewDateChanged } from 'mini-calendar-agenda-store/lib/actions/publicActions';
import { onDayViewDateChanged } from 'mini-calendar-dayview-store/lib/actions/publicActions';

const onDateChange = actionMessage => {
    const { newDate } = actionMessage;
    const store = getSurfaceStore();
    if (getTimestamp(store.selectedDate) !== getTimestamp(newDate)) {
        store.selectedDate = newDate;
        store.dateToNavigate = newDate;
    }
};

/**
 * Mutate selectedDate and dateToNavigate when agenda view is scrolled resulting in updation of selected date
 */
export const onAgendaViewDateChangedMutator = mutator(onAgendaViewDateChanged, onDateChange);

/**
 * Mutate selectedDate and dateToNavigate when day view is swiped resulting in updation of selected date
 */
export const onDayViewDateChangedMutator = mutator(onDayViewDateChanged, onDateChange);

/**
 * Sets selected date in surface store
 * @param date The value to be set as selectedDate in surface store
 */
export const setSelectedDate = mutatorAction('setSelectedDate', (date: OwaDate) => {
    if (
        !getSurfaceStore().selectedDate ||
        getTimestamp(getSurfaceStore().selectedDate) !== getTimestamp(date)
    ) {
        getSurfaceStore().selectedDate = date;
    }
});

/**
 * Sets todayDate in surface store
 * @param date The value to be set as todayDate in surface store
 */
export const setTodayDate = mutatorAction('setTodayDate', (date: OwaDate, ctx?: any) => {
    if (
        !getSurfaceStore().todayDate ||
        getTimestamp(getSurfaceStore().todayDate) !== getTimestamp(date)
    ) {
        getSurfaceStore().todayDate = date;
    }
    ctx && ctx.signal('setTodayDate', { todayDate: getDateString(date) });
});

/**
 * Initializes all the surface store dates to a given date on bootstrap
 * @param date The value to be set
 */
export const initializeSurfaceStoreDates = mutatorAction('initializeDates', (date: OwaDate) => {
    const surfaceStore = getSurfaceStore();
    if (
        !surfaceStore.selectedDate ||
        getTimestamp(surfaceStore.selectedDate) !== getTimestamp(date)
    ) {
        surfaceStore.selectedDate = date;
    }
    if (!surfaceStore.todayDate || getTimestamp(surfaceStore.todayDate) !== getTimestamp(date)) {
        surfaceStore.todayDate = date;
    }
    surfaceStore.dateToNavigate = date;
});
